import history from 'history.js'

import PATH from '../../../business-const/Path/Path'

import ClienteService from '../../../business-api/ClienteService'

import {
    dataAtual,
} from '../../../business-components/Date/Date'

import {
    putClienteInfoclient,
} from '../cliente-form/ClienteService'

import {
    calculaComparacaoEstudos
} from '../estudo-parametros/EstudoServiceCenarios'



export const selecionaVersao = (variaveisGlobais, values, versao) => {

    history.push({
        pathname: PATH.pageVersaoFormRedirect,
        variaveisGlobais: variaveisGlobais,
        idUsuario: ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
        idCliente: values.id,
        ultimaVersao: values.ultimaVersao,
        jsonComparacaoEstudos: JSON.stringify(values.jsonComparacaoEstudos),
        versao: versao, 
    })
}

export const incluiVersao = async (variaveisGlobais, values) => {

    const ultimaVersao = values.ultimaVersao
    const jsonComparacaoEstudos = {...values.jsonComparacaoEstudos}
    const versao = values.versao
    const dataSimulacaoEstudo = values.dataSimulacaoEstudo

    values.ultimaVersao++
    values.versao = values.ultimaVersao
    values.dataSimulacaoEstudo = dataAtual()
    
    values.cenarios?.forEach( (linha, ind) => {

        values.cenarios[ind].dataSimulacaoEstudo = values.dataSimulacaoEstudo
    })

    calculaComparacaoEstudos(values)

    const status = await putClienteInfoclient(variaveisGlobais, null, values, null, null, null)

    if (status) {

        selecionaVersao(variaveisGlobais, values, values.ultimaVersao)

    } else {

        values.ultimaVersao = ultimaVersao
        values.jsonComparacaoEstudos = jsonComparacaoEstudos
        values.versao = versao
        values.dataSimulacaoEstudo = dataSimulacaoEstudo

        selecionaVersao(variaveisGlobais, values, values.ultimaVersao)
    }
}